import approvedInvoiceDtls from './approvedInvoiceDtls';
import commonHelper from '@/app/utility/common.helper.utility';
import { required } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import URL_UTILITY from '../../../../../utility/url.utility';
export default {
  components: { approvedInvoiceDtls, DatePicker },
  watch: {
    filedFlag: function() {
      this.getSearchData();
    }
  },
  data() {
    return {
      customerapprovedinvoices: 32,
      approvedkeyData: [],
      //approvedkeyData: [{totalapprovedinvoices:{{level_1}}+{{level_2}}+{{level_3}}+{{level_4}}+{{level_5}}+{{level_6}}+{{level_7}}}],
      loading: false,
      // showModal: false,
      // shoModal: false,
      invDateFrom: null,
      invDateTo: null,
      approvedkeyField: [
        {
          key: 'commercial_bucket',
          // label: '↓ Commercial/Financial →',
          label:
            '<span style="color: rgb(72, 177, 72);">↓ Commercial</span>/<span ">Financial →</span>',
          class: 'text-center wide-column'
        },
        {
          key: 'level_1',
          label: '00-05 Days',
          class: 'text-center wide-column-level'
        },
        {
          key: 'level_2',
          label: '06-10 Days',
          class: 'text-center wide-column-level'
        },
        {
          key: 'level_3',
          label: '11-15 Days',
          class: 'text-center wide-column-level'
        },
        {
          key: 'level_4',
          label: '16-20 Days',
          class: 'text-center wide-column-level'
        },
        {
          key: 'level_5',
          label: '21-31 Days',
          class: 'text-center wide-column-level'
        },
        // { key: 'level_6', label: '26-31Days'  ,class:"text-center" },
        {
          key: 'level_6',
          label: '31+ Days',
          class: 'text-center wide-column-level'
        },
        {
          key: 'totalapprovedinvoices',
          label: 'Total',
          class: 'text-center wide-column-level '
        }
        // {
        //   key: 'total',
        //   label: 'Total',
        //   class: 'text-center wide-column-level'
        // }
        // { key: 'commercial_count', label: 'Commercial Count' ,class:"text-center maxWidth" },
      ],
      showApprInvDtlsModal: false,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: true,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      },
      rowMatrixIndexes: {
        f_lower: null,
        f_upper: null,
        c_lower: null,
        c_upper: null,
        from_date: null,
        to_date: null,
        fieldType: null
      },
      //filedFlag: false,
      fieldType: null,
      filedFlag: 'approved',
      requestStatus: null,
      templateId: null,
      requestId: null,
      dowloadReport: URL_UTILITY.getDownloadReportUrl,
      reqStId:null,
      //totalapprovedvoices2:null,
    };
  },
  validations: {
    invDateFrom: { required },
    invDateTo: { required }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'download') {
          if (this.invDateFrom && this.invDateTo) {
            this.getTemplateDetails();
          } else {
            this.$bvToast.toast('Please Select Invoice Date From and To', {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        }
      }
    });
  },

  methods: {
    getSearchData() {
      this.$v.$touch();

      if (this.$v.$invalid || !this.invDateFrom || !this.invDateTo) {
        this.approvedkeyData = [];
        return;
      }

      if (this.filedFlag == 'finance') {
        this.fieldType = 'Pending On Finance';
        this.getInprocessInvoicedata();
      } else if (this.filedFlag == 'approved') {
        this.fieldType = 'Approved';
        this.getapprovedincoicedata();
      } else {
        this.fieldType = 'commercial';
        this.getPendingCommercialData();
      }
    },
    getapprovedincoicedata() {
      let payload = {
        from_date: this.invDateFrom,
        to_date: this.invDateTo
      };
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/getapprovedincoicedata', payload)
        .then(response => {
          if (response.status === 200) {
            this.approvedkeyData = response.data.data;
            let lev1 = 0;
            let lev2 = 0;
            let lev3 = 0;
            let lev4 = 0;
            let lev5 = 0;
            let lev6 = 0;
            let tott = 0;

            for (let i = 0; i < this.approvedkeyData.length; i++) {
              const item = this.approvedkeyData[i];
              let totalApprovedInvoices = 0;

              totalApprovedInvoices += item.level_1;
              totalApprovedInvoices += item.level_2;
              totalApprovedInvoices += item.level_3;
              totalApprovedInvoices += item.level_4;
              totalApprovedInvoices += item.level_5;
              totalApprovedInvoices += item.level_6;
              // totalApprovedInvoices += (item.level_7);
              lev1 += item.level_1;
              lev2 += item.level_2;
              lev3 += item.level_3;
              lev4 += item.level_4;
              lev5 += item.level_5;
              lev6 += item.level_6;
              tott += totalApprovedInvoices;

              this.approvedkeyData[
                i
              ].totalapprovedinvoices = totalApprovedInvoices;
            }
            let x = lev1 + lev2 + lev3 + lev4 + lev5 + lev6;
            this.approvedkeyData.push({
              commercial_bucket: 'Total',
              level_1: lev1,
              level_2: lev2,
              level_3: lev3,
              level_4: lev4,
              level_5: lev5,
              level_6: lev6,
              totalapprovedinvoices: `${this.getColoredX(x)}/${tott}`
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      // }
    },
    getInprocessInvoicedata() {
      let payload = {
        from_date: this.invDateFrom,
        to_date: this.invDateTo
      };
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/getInprocessInvoicedata', payload)
        .then(response => {
          if (response.status === 200) {
            this.approvedkeyData = response.data.data;
            let lev1 = 0;
            let lev2 = 0;
            let lev3 = 0;
            let lev4 = 0;
            let lev5 = 0;
            let lev6 = 0;
            let tott = 0;
            for (let i = 0; i < this.approvedkeyData.length; i++) {
              const item = this.approvedkeyData[i];
              let totalApprovedInvoices = 0;

              totalApprovedInvoices += item.level_1;
              totalApprovedInvoices += item.level_2;
              totalApprovedInvoices += item.level_3;
              totalApprovedInvoices += item.level_4;
              totalApprovedInvoices += item.level_5;
              totalApprovedInvoices += item.level_6;
              lev1 += item.level_1;
              lev2 += item.level_2;
              lev3 += item.level_3;
              lev4 += item.level_4;
              lev5 += item.level_5;
              lev6 += item.level_6;
              tott += totalApprovedInvoices;
              this.approvedkeyData[
                i
              ].totalapprovedinvoices = totalApprovedInvoices;
            }
            let x = lev1 + lev2 + lev3 + lev4 + lev5 + lev6;
            this.approvedkeyData.push({
              commercial_bucket: 'Total',
              level_1: lev1,
              level_2: lev2,
              level_3: lev3,
              level_4: lev4,
              level_5: lev5,
              level_6: lev6,
              totalapprovedinvoices: `${this.getColoredX(x)}/${tott}`
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getPendingCommercialData() {
      let payload = {
        from_date: this.invDateFrom,
        to_date: this.invDateTo
      };
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/getPendingCommercialData', payload)
        .then(response => {
          if (response.status === 200) {
            this.approvedkeyData = response.data.data;
            let lev1 = 0;
            let lev2 = 0;
            let lev3 = 0;
            let lev4 = 0;
            let lev5 = 0;
            let lev6 = 0;
            let tott = 0;
            for (let i = 0; i < this.approvedkeyData.length; i++) {
              const item = this.approvedkeyData[i];
              let totalApprovedInvoices = 0;

              totalApprovedInvoices += item.level_1;
              totalApprovedInvoices += item.level_2;
              totalApprovedInvoices += item.level_3;
              totalApprovedInvoices += item.level_4;
              totalApprovedInvoices += item.level_5;
              totalApprovedInvoices += item.level_6;
              lev1 += item.level_1;
              lev2 += item.level_2;
              lev3 += item.level_3;
              lev4 += item.level_4;
              lev5 += item.level_5;
              lev6 += item.level_6;
              tott += totalApprovedInvoices;
              // totalApprovedInvoices += (item.level_7);

              this.approvedkeyData[
                i
              ].totalapprovedinvoices = totalApprovedInvoices;
            }
            let x = lev1 + lev2 + lev3 + lev4 + lev5 + lev6;
            this.approvedkeyData.push({
              commercial_bucket: 'Total',
              level_1: lev1,
              level_2: lev2,
              level_3: lev3,
              level_4: lev4,
              level_5: lev5,
              level_6: lev6,
              totalapprovedinvoices: `${this.getColoredX(x)}/${tott}`
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getColoredX(x) {
      let color = 'black'; // Default color
      if (x >= 0) {
        color = 'green';
      }

      // Return the x value wrapped in a span with an inline style for color
      return `<span style="color: ${color};">${x}</span>`;
    },
    disabledDates(date) {
      return commonHelper.disabledDates(date, this.invDateFrom);
    },
    openModal() {
      this.showModal = true;
    },
    clearAllData() {
      this.invDateFrom = null;
      this.invDateTo = null;
      this.approvedkeyData = [];
    },
    showInvoiceDtls(data) {
      if (
        this.fieldType === 'Approved' ||
        this.fieldType === 'Pending On Finance'
      ) {
        let financialObj = this.bifurcateRange(data.field.label);
        let commercialObj = this.bifurcateRange(data.item.commercial_bucket);
        this.rowMatrixIndexes = {
          f_lower: financialObj.start,
          f_upper: financialObj.end,
          c_lower: commercialObj.start,
          c_upper: commercialObj.end,
          from_date: this.invDateFrom,
          to_date: this.invDateTo,
          fieldType: this.fieldType
        };
      } else {
        let commercialObj = this.bifurcateRange(data.field.label);
        this.rowMatrixIndexes = {
          c_lower: commercialObj.start,
          c_upper: commercialObj.end,
          from_date: this.invDateFrom,
          to_date: this.invDateTo,
          fieldType: this.fieldType
        };
      }
      this.showApprInvDtlsModal = true;
    },
    bifurcateRange(range) {
      let cleanedRange = range.replace('Days', '').trim();

      if (cleanedRange.includes('+')) {
        let start = parseInt(cleanedRange);
        return { start, end: null };
      }
      let [start, end] = cleanedRange.split('-').map(Number);
      return { start, end };
    },
    showHideApprInvDtlsModal(flag) {
      this.showApprInvDtlsModal = flag;
    },
    toggle() {
      this.filedFlag != this.filedFlag;
      this.approvedkeyData = [];
    },
    callFunc() {
      this.requestStatus = null;
      if (this.filedFlag == 'commercial') {
        this.approvedkeyField = [
          {
            key: 'commercial_bucket',
            // label: '↓ Commercial/Financial →',
            label: '<span style="color: rgb(72, 177, 72);">↓ Commercial</span>',
            class: 'text-center wide-column'
          },
          {
            key: 'level_1',
            label: '00-05 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_2',
            label: '06-10 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_3',
            label: '11-15 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_4',
            label: '16-20 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_5',
            label: '21-31 Days',
            class: 'text-center wide-column-level'
          },
          // { key: 'level_6', label: '26-31Days'  ,class:"text-center" },
          {
            key: 'level_6',
            label: '31+ Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'totalapprovedinvoices',
            label: 'Total',
            class: 'text-center wide-column-level'
          }
          // { key: 'commercial_count', label: 'Commercial Count' ,class:"text-center maxWidth" },
        ];
      } else {
        this.approvedkeyField = [
          {
            key: 'commercial_bucket',
            // label: '↓ Commercial/Financial →',
            label:
              '<span style="color: rgb(72, 177, 72);">↓ Commercial</span>/<span ">Financial →</span>',
            class: 'text-center wide-column'
          },
          {
            key: 'level_1',
            label: '00-05 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_2',
            label: '06-10 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_3',
            label: '11-15 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_4',
            label: '16-20 Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'level_5',
            label: '21-31 Days',
            class: 'text-center wide-column-level'
          },
          // { key: 'level_6', label: '26-31Days'  ,class:"text-center" },
          {
            key: 'level_6',
            label: '31+ Days',
            class: 'text-center wide-column-level'
          },
          {
            key: 'totalapprovedinvoices',
            label: 'Total',
            class: 'text-center wide-column-level'
          }
          // { key: 'commercial_count', label: 'Commercial Count' ,class:"text-center maxWidth" },
        ];
      }
    },
    // objConvert(data) {
    //   const buckets = ["0-5 Days", "6-10 Days", "11-15 Days", "16-20 Days", "21-25 Days", "26-31 Days", "31+ Days"];

    //   return data.map(item => {
    //     const result = {
    //       "commercial_count": item.commercial_count,
    //       "commercial_bucket": item.commercial_bucket
    //     };

    //     buckets.forEach(bucket => {
    //       result[bucket] = 0;
    //     });

    //     result[item.finance_bucket] = item.finance_count;

    //     return result;
    //   });
    // }
  getTemplateDetails() {
      const payload = {
        _page: 0,
        _limit: 10,
        template_name:
          this.filedFlag === 'approved'
            ? 'Invoice_Pending_Report_Template'
            : this.filedFlag === 'finance'
            ? 'Invoice_Inprocess_Template'
            : 'Pending_At_Commercial_Template'
      };
      this.loader = true;
      this.$store
        .dispatch('assets/getTemplateDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.requestId = resp.data.data.page[0].request_id;
            this.templateId = resp.data.data.page[0].template_id;
            this.saveSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    saveSubmitRequest() {
      const payload = {
        admin_submit_req_details: [
          {
            request_num: 0,
            request_id: this.requestId,
            template_id: this.templateId,
            schedule_type: 'asap', //pass hardcode
            request_start_date: null,
            request_end_date: null,
            resubmit_interval: null,
            resubmit_interval_unit: null,
            day_of_month: null,
            day_of_week: null,
            output_format_id: 'XLS', //pass hardcode
            no_of_args: 25,
            request_parameter: null,
            sms_flag: false,
            email_flag: false,
            whatsapp_flag: false,
            child_req_count: null,
            email_comm_template_id: null,
            sms_comm_template_id: null,
            whatsapp_comm_template_id: null,
            argument1: this.invDateFrom,
            argument2: this.invDateTo,
            argument3: null,
            argument4: null,
            argument5: null,
            argument6: null,
            argument7: null,
            argument8: null,
            argument9: null,
            argument10: null,
            argument11: null,
            argument12: null,
            argument13: null,
            argument14: null,
            argument15: null,
            argument16: null,
            argument17: null,
            argument18: null,
            argument19: null,
            argument20: null,
            argument21: null,
            argument22: null,
            argument23: null,
            argument24: null,
            argument25: null
          }
        ]
      };
      this.loader = true;
      this.$store
        .dispatch('template/saveSubmitRequest', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 201) {
            this.requestNumId = resp.data.data[0].id;
            this.getSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getSubmitRequest() {
      this.loader = true;
      this.$store
        .dispatch('template/getSubmitRequest', this.requestNumId)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.requestStatus = resp.data.data[0].status;
            this.reqStId=resp.data.data[0].id;  
            // if (this.requestStatus === 'COMPLETED') {
            //   this.loader = false;
            //   window.location.href = this.dowloadReport + '/' + this.reqStId;
            // }   
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
